"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_popper_1 = require("react-popper");
var react_transition_group_1 = require("react-transition-group");
var portal_1 = __importDefault(require("@components/portal"));
var hooks_1 = require("./hooks");
var style_1 = require("./style");
var Wrapper = function (_a) {
    var children = _a.children, container = _a.container;
    return ((container !== null)
        ? react_1.default.createElement(portal_1.default, { container: container }, children)
        : react_1.default.createElement(react_1.Fragment, null, children));
};
var Tooltip = react_1.forwardRef(function (_a, forwardedRef) {
    var _b;
    var _c, _d, _e;
    var children = _a.children, containerClassName = _a.containerClassName, containerStyle = _a.containerStyle, content = _a.content, _f = _a.eventOff, eventOff = _f === void 0 ? 'onMouseLeave' : _f, _g = _a.eventOn, eventOn = _g === void 0 ? 'onMouseEnter' : _g, isOpen = _a.isOpen, onClose = _a.onClose, onOpen = _a.onOpen, _h = _a.placement, wantedPlacement = _h === void 0 ? 'bottom' : _h, title = _a.title, portalID = _a.portalID, variant = _a.variant, wrapperClassName = _a.wrapperClassName, wrapperStyle = _a.wrapperStyle, _j = _a.withCaptureClick, withCaptureClick = _j === void 0 ? false : _j, _k = _a.withOnHover, withOnHover = _k === void 0 ? true : _k, _l = _a.withPortal, withPortal = _l === void 0 ? false : _l;
    var _m = hooks_1.useOpen(onOpen, onClose), open = _m.open, handleOpen = _m.handleOpen, handleClose = _m.handleClose, toggleOpen = _m.toggleOpen;
    var triggerRef = react_1.useRef(null);
    var _o = react_1.useState(null), popper = _o[0], setPopper = _o[1];
    var _p = react_1.useState(null), arrow = _p[0], setArrow = _p[1];
    var _q = react_popper_1.usePopper(triggerRef.current, popper, {
        modifiers: [
            { name: 'arrow', options: { element: arrow } },
            { name: 'offset', options: { offset: [0, style_1.ARROW_SIZE] } }
        ],
        placement: wantedPlacement
    }), attributes = _q.attributes, state = _q.state, styles = _q.styles;
    var container = ((withPortal && portalID !== undefined)
        ? document.getElementById("portal-" + portalID)
        : null);
    var isInControlledMode = isOpen !== undefined;
    var isDisplayed = isInControlledMode ? Boolean(isOpen) : open;
    var isTouchDevice = (_e = (_d = (_c = window === null || window === void 0 ? void 0 : window.matchMedia) === null || _c === void 0 ? void 0 : _c.call(window, '(pointer: coarse)')) === null || _d === void 0 ? void 0 : _d.matches) !== null && _e !== void 0 ? _e : false;
    var eventHandlers = (_b = {},
        _b[eventOff] = !isInControlledMode ? handleClose : undefined,
        _b[eventOn] = !isInControlledMode ? handleOpen : undefined,
        _b);
    var handleOnClick = function (event) {
        if (withCaptureClick) {
            event.stopPropagation();
            event.preventDefault();
        }
        if (!isInControlledMode) {
            toggleOpen();
        }
    };
    var handleOnMouseEnter = ((!isInControlledMode && withOnHover && !isTouchDevice)
        ? handleOpen
        : undefined);
    var handleOnMouseLeave = ((!isInControlledMode && (withOnHover || eventOff === 'onMouseLeave'))
        ? handleClose
        : undefined);
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(style_1.Trigger, __assign({}, eventHandlers, { className: wrapperClassName, onClick: handleOnClick, onMouseEnter: handleOnMouseEnter, onMouseLeave: handleOnMouseLeave, ref: triggerRef, style: wrapperStyle }), children),
        react_1.default.createElement(Wrapper, { container: container },
            react_1.default.createElement(react_transition_group_1.CSSTransition, { appear: true, mountOnEnter: true, unmountOnExit: true, in: isDisplayed, timeout: style_1.ANIMATION_DURATION },
                react_1.default.createElement(style_1.InnerWrapper, null,
                    react_1.default.createElement("div", { ref: forwardedRef },
                        react_1.default.createElement(style_1.Container, __assign({ className: containerClassName, ref: setPopper, style: __assign(__assign({}, styles === null || styles === void 0 ? void 0 : styles.popper), containerStyle), variant: variant }, attributes === null || attributes === void 0 ? void 0 : attributes.popper),
                            (title !== undefined) ? (react_1.default.createElement("div", { className: 'Tooltip__title' }, title)) : null,
                            (content !== undefined) ? (react_1.default.createElement("div", { className: 'Tooltip__content' }, content)) : null,
                            react_1.default.createElement(style_1.Arrow, { placement: state === null || state === void 0 ? void 0 : state.placement, ref: setArrow, style: styles === null || styles === void 0 ? void 0 : styles.arrow, variant: variant }))))))));
});
Tooltip.displayName = 'Tooltip';
exports.default = Tooltip;
__exportStar(require("./types"), exports);
